import { isMobile } from 'react-device-detect';
import isBrowser from './isBrowser';
import { createWebVideo } from './videoCreator/webVideoCreator';
import { createMobileVideo } from './videoCreator/mobileVideoCreator';

export default isMobile && !isBrowser() ? createMobileVideo : createWebVideo;
